import React from "react";
import DateUtils from "../../../../../../../core/services/date-utils";
import Grid2 from "@mui/material/Unstable_Grid2";
import {useFormV2, Yup} from '../../../../../../components/form';
import ValidateMessages from "../../../../../../../core/models/static/texts/vallidate-messages";
import {DateRangeButton, DateRangeUtils} from "../../../../../../components/app-specific/date-range-controller";

export const createDateRangeSchema = ({startDateRequired = false, endDateRequired = false} = {}) => {
    return {
        dateRangeValue: (startDateRequired || endDateRequired)
            ? Yup.mixed().required(ValidateMessages.required)
            : Yup.mixed().nullable().optional(),
    }
}

export const createDateRangeInitialValues = (filters) => {
    return {
        dateRangeValue: DateRangeUtils.getDateRangeValueFromLegacyFilters(filters),
    }
}

export const prepareDateRangeFilters = (filters) => {
    const range = {
        startDate: undefined,
        endDate: undefined,
    }
    const dateRangeValue = DateRangeUtils.getDateRangeValueFromLegacyFilters(filters);
    if (dateRangeValue) {
        const determinedRange = DateRangeUtils.getDateRange(dateRangeValue);
        if (determinedRange) {
            const [determinedStart, determinedEnd] = determinedRange;
            range.startDate = determinedStart ? DateUtils.localToServer(determinedStart).format(DateUtils.withoutOffsetFormat) : determinedStart;
            range.endDate = determinedEnd ? DateUtils.localToServer(determinedEnd).format(DateUtils.withoutOffsetFormat) : determinedEnd;
        }
    }
    return range;
}

export const DateRangeFormSection = ({required}) => {
    const {values, form, submitting} = useFormV2();

    return (
        <Grid2 xs={12} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 1}}>
            <DateRangeButton
                disabled={submitting}
                disallowedTypes={['next']}
                disallowedBatches={['hour']}
                disallowFromNow
                value={values.dateRangeValue}
                onCommitted={(val) => {
                    form.change('dateRangeValue', val);
                }}
            />
        </Grid2>
    );
}
